import { render, staticRenderFns } from "./privacyhead.vue?vue&type=template&id=70a9a5d6&scoped=true"
import script from "./privacyhead.vue?vue&type=script&lang=js"
export * from "./privacyhead.vue?vue&type=script&lang=js"
import style0 from "./privacyhead.vue?vue&type=style&index=0&id=70a9a5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9a5d6",
  null
  
)

export default component.exports